import React from "react";
import MInputAdornment from "@mui/material/InputAdornment";

const InputAdornment = (props) => {
    return <MInputAdornment {...props} />
}

export default InputAdornment;